import type { RadioButtonTokens } from './types';

export const radioButton: RadioButtonTokens = {
  borders: {
    default: '2',
  },
  colors: {
    label: 'neutral.80',
    tick: {
      default: {
        iconColor: 'neutral.10',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'neutral.50',
        },
      },
      error: {
        iconColor: 'critical.70',
        bgColor: 'critical.30',
        labelColor: 'critical.50',
        borderColor: 'critical.50',
      },
      disabled: {
        iconColor: 'neutral.80',
        bgColor: 'neutral.50',
        borderColor: 'neutral.50',
      },
      checked: {
        iconColor: 'brandPrimary.1',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'neutral.50',
        },
      },
    },
    circle: {
      default: {
        iconColor: 'neutral.10',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'neutral.50',
        },
      },
      error: {
        iconColor: 'critical.70',
        bgColor: 'critical.30',
        labelColor: 'critical.50',
        borderColor: 'critical.50',
      },
      disabled: {
        iconColor: 'neutral.80',
        bgColor: 'neutral.50',
        borderColor: 'neutral.50',
      },
      checked: {
        iconColor: 'brandPrimary.1',
        bgColor: 'neutral.10',
        borderColor: 'neutral.50',
        hover: {
          borderColor: 'neutral.50',
        },
      },
    },
  },
  sizes: {
    minWidth: '20px',
    height: '20px',
  },
  lineHeight: {
    default: 'body',
  },
  fontSizes: {
    default: '1',
  },
  fontWeights: {
    unchecked: 'normal',
    checked: 'medium',
  },
};
